var outlineOffset = 2;
var outlineWidth = 2;
export { outlineOffset, outlineWidth };